import React from "react";
import { FieldError, UseFormRegister } from "react-hook-form";

interface YearsProps {
  name: string;
  register: UseFormRegister<any>;
  error?: FieldError;
  selected?: string | number;
  type?: string;
  validationRules?: object;
  disabled?: boolean;
}

const Years: React.FC<YearsProps> = ({
  name,
  register,
  error,
  selected,
  type,
  validationRules,
  disabled,
}) => {
  const currentYear = new Date().getFullYear();
  const startYear = 2000;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i,
  );

  return (
    <>
      <select
        {...register(name, validationRules)}
        defaultValue={selected ?? ""}
        disabled={disabled}
        className={`h-9 w-full border px-4 py-1 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10 ${
          error ? "border-red-500" : ""
        }`}
      >
        <option value="">Select year</option>
        {years.map((year) => (
          <option key={year} value={type === "number" ? year : `${year}`}>
            {year}
          </option>
        ))}
      </select>
      {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
    </>
  );
};

export default Years;
